import React from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { KTCard, KTCardBody } from '../../../../_metronic/helpers'



const FileManagerSettingsPage: React.FC = () => {
  return (
    <>
      <PageTitle>Gerenciador de Arquivos - Configurações</PageTitle>
      <KTCard>
        <KTCardBody>
          <form className='form'>
            <div className='mb-10'>
              <label className='form-label'>Nome do Repositório</label>
              <input type='text' className='form-control' defaultValue='Arquivo Principal' />
            </div>
            <div className='mb-10'>
              <label className='form-label'>Permitir compartilhamento externo</label>
              <select className='form-select'>
                <option>Sim</option>
                <option>Não</option>
              </select>
            </div>
            <button type='submit' className='btn btn-primary'>Salvar</button>
          </form>
        </KTCardBody>
      </KTCard>
    </>
  )
}

export default FileManagerSettingsPage
